var render, staticRenderFns
import script from "./GravatarMixin.vue?vue&type=script&lang=js"
export * from "./GravatarMixin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "781663c4",
  null
  
)

export default component.exports